/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-category-item.reducer';

export const LabTestCategoryItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestCategoryItemEntity = useAppSelector(state => state.labTestCategoryItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestCategoryItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.detail.title">LabTestCategoryItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryItemEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryItemEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryItemEntity.timestampentry}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestCategoryItemEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.lcTestItem">Lc Test Item</Translate>
          </dt>
          <dd>{labTestCategoryItemEntity.lcTestItem ? labTestCategoryItemEntity.lcTestItem.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestCategoryItem.lcTestCategory">Lc Test Category</Translate>
          </dt>
          <dd>{labTestCategoryItemEntity.lcTestCategory ? labTestCategoryItemEntity.lcTestCategory.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-category-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-category-item/${labTestCategoryItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestCategoryItemDetail;
